module.exports = "/assets/data/e7c1560d620de23044f2f8305f35b36f-N2.data.json";